// extracted by mini-css-extract-plugin
export default {"featuresItem":"KQFAd","imgWrapper":"C_NMe","videoContainer":"Hd_id","image":"GFbEk","iconPlay":"eurjq","name":"T30Gx","description":"zQuCR","video":"WxMqO"};